


export const API_URL = process.env.REACT_APP_API_URL ;

export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL ;

export const BASE_URL = process.env.REACT_APP_SOCKET_URL;  